// shared/src/schemas/target-calibration.ts
// Zod row-guard for the Track B target-ticker calibration table (DDL:
// migrations/0066_rank_probe_and_target_calibration.sql §11.2). Plain z.object
// so the schema-vs-ddl drift detector's getZodFields() reads .shape. Field
// names mirror the DDL columns 1:1.
//
// Track B = the two K1–K4 gaps (magnitude calibration + benchmark nulls),
// computed from daily_closes at fixed-14d + native horizons. direction_hit /
// brier_contribution here are the 14d/native cut, complementary to K1–K3.
// docs/cross-sectional-rank-ic-2026-06-25-brief-revision.md §11.

import { z } from 'zod';

export const TargetCalibrationHorizonKindEnum = z.enum(['fixed14', 'native']);

// ── target_calibration_outcomes (19 cols) ───────────────────────────────────
export const TargetCalibrationOutcomeSchema = z.object({
  id:                   z.string(),
  signal_id:            z.string(),
  ticker:               z.string(),
  brief_id:             z.string(),
  horizon_kind:         TargetCalibrationHorizonKindEnum,
  resolves_at:          z.string(),
  predicted_direction:  z.enum(['long', 'short']),
  realized_direction:   z.enum(['long', 'short']),
  direction_hit:        z.number().int(),
  confidence_bucket:    z.enum(['HIGH', 'MED', 'LOW']),
  predicted_prob:       z.number(),
  brier_contribution:   z.number(),
  predicted_change_pct: z.number().nullable(),
  realized_return:      z.number(),
  magnitude_error:      z.number().nullable(),
  momentum_hit:         z.number().int(),
  rw_hit:               z.number().int(),
  scorer_version:       z.string(),
  scored_at:            z.string(),
});
export type TargetCalibrationOutcomeRow = z.infer<typeof TargetCalibrationOutcomeSchema>;
